import * as actionTypes from "./actionTypes";

export default function assetReducer(state = [], action) {
  switch (action.type) {
    case actionTypes.MODIFY_ASSETS:
      return [...action.assets];
    default:
      return state;
  }
}
